import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipListboxChange, MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule } from '@angular/material/core';
import {
  MatDatepickerInputEvent,
  MatDatepickerModule,
} from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSidenavModule } from '@angular/material/sidenav';
import {
  endOfISOWeek,
  endOfMonth,
  format,
  isFirstDayOfMonth,
  isLastDayOfMonth,
  isSameDay,
  isToday,
  parse,
  startOfISOWeek,
  startOfMonth,
} from 'date-fns';
import { FilterOutput, FilterParams } from '../../models/filter-params';
import { FilterHeaderComponent } from '../filter-header/range-date-filter.component';

type TypeDateRange = 'today' | 'week' | 'month' | 'custom';
const labelTypeDateRange: Record<TypeDateRange, string> = {
  today: 'Hoy',
  week: 'Semana',
  month: 'Mes',
  custom: 'Personalizado',
};
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'edt-range-date-filter',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    OverlayModule,
    MatFormFieldModule,
    MatInputModule,
    MatChipsModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatMenuModule,
    MatSidenavModule,
    FilterHeaderComponent,
  ],
  templateUrl: './range-date-filter.component.html',
  styleUrls: ['./range-date-filter.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RangeDateFilterComponent implements OnInit, OnDestroy {
  isOpen = false;
  activeFilter = new Map<string, string>();
  startDate: Date | null = null;
  endDate: Date | null = null;
  maxDate = new Date();
  selectedStatus: TypeDateRange = 'today';
  @Input() initialFilter: FilterParams | null = null;
  @Output() filterChanged = new EventEmitter<FilterOutput>();

  ngOnInit(): void {
    let start = new Date();
    let end = new Date();
    if (this.initialFilter && this.initialFilter['from_date']) {
      start = parse(
        String(this.initialFilter['from_date']),
        'yyyy-MM-dd',
        start
      );
    }
    if (this.initialFilter && this.initialFilter['to_date']) {
      end = parse(String(this.initialFilter['to_date']), 'yyyy-MM-dd', end);
    }
    if (isFirstDayOfMonth(start) && isLastDayOfMonth(end)) {
      this.selectedStatus = 'month';
    } else if (
      isSameDay(startOfISOWeek(new Date()), start) &&
      isSameDay(endOfISOWeek(new Date()), end)
    ) {
      this.selectedStatus = 'custom';
    } else if (isToday(start) && isToday(end)) {
      this.selectedStatus = 'today';
    } else {
      this.startDate = start;
      this.endDate = end;
    }
    this.activeFilter.set('from_date', format(start, 'yyyy-MM-dd'));
    this.activeFilter.set('to_date', format(end, 'yyyy-MM-dd'));
  }

  ngOnDestroy(): void {
    this.activeFilter.clear();
  }

  cancel(): void {
    this.isOpen = false;
  }

  statusChanged(ev: MatChipListboxChange): void {
    if (ev.value) {
      this.selectedStatus = ev.value;
      this.startDate = null;
      this.endDate = null;
    } else {
      this.selectedStatus = 'custom';
    }
  }

  startChanged(ev: MatDatepickerInputEvent<Date>): void {
    if (ev.value) {
      this.startDate = ev.value;
      this.selectedStatus = 'custom';
    } else {
      this.startDate = null;
    }
  }

  endChanged(ev: MatDatepickerInputEvent<Date>): void {
    if (ev.value) {
      this.endDate = ev.value;
      this.selectedStatus = 'custom';
    } else {
      this.endDate = null;
    }
  }

  toogleSelected(val: string): boolean {
    return this.selectedStatus && this.selectedStatus === val ? true : false;
  }

  close(event: MouseEvent) {
    this.isOpen = false;
    console.log(event);
  }

  applyFilter(): void {
    const today = new Date();
    let startRange = new Date();
    let endRange = new Date();

    switch (this.selectedStatus) {
      case 'today':
        startRange = new Date();
        endRange = startRange;
        break;
      case 'week':
        startRange = startOfISOWeek(today);
        endRange = endOfISOWeek(today);
        break;

      case 'month':
        startRange = startOfMonth(today);
        endRange = endOfMonth(today);
        break;
    }

    this.activeFilter.set('from_date', format(startRange, 'yyyy-MM-dd'));
    this.activeFilter.set('to_date', format(endRange, 'yyyy-MM-dd'));

    const newObject = Object.fromEntries(this.activeFilter);
    this.filterChanged.emit({
      name: labelTypeDateRange[this.selectedStatus],
      filter: newObject,
    });
    this.isOpen = false;
  }

  toogleOpen(open: boolean) {
    this.isOpen = open;
    console.log(open);
  }
}
